import ChatConversasPage from "@/Pages/Chat/ChatConversasPage.vue";
import { aplicarModulos } from "./modulos";

const rotas = [
  {
    path: "/chat/conversas",
    name: "chat.conversas",
    component: ChatConversasPage,
  },
];

// Rota => módulo (Administração > Configurações).
const MODULO_POR_ROTA = {
  "chat.conversas": "mensagens",
};

export default aplicarModulos(rotas, MODULO_POR_ROTA);
